import { render, staticRenderFns } from "./My_Topic.vue?vue&type=template&id=3d6e7bee&scoped=true"
import script from "./My_Topic.vue?vue&type=script&lang=js"
export * from "./My_Topic.vue?vue&type=script&lang=js"
import style0 from "./My_Topic.vue?vue&type=style&index=0&id=3d6e7bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e7bee",
  null
  
)

export default component.exports